module.exports = __webpack_public_path__ + "45463ee6f9675e59c293520a3f75ba2b.svg";